import { render, staticRenderFns } from "./MerchandisingProduct.vue?vue&type=template&id=5e58f32c"
import script from "./MerchandisingProduct.vue?vue&type=script&lang=js"
export * from "./MerchandisingProduct.vue?vue&type=script&lang=js"
import style0 from "./MerchandisingProduct.vue?vue&type=style&index=0&id=5e58f32c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports